module.exports = __webpack_public_path__ + "img/brand-06.8e38619b.png";